<template>
  <div class="reports-dashboard">
    <div class="container mt-5 mb-5">
      <div class="row">
        <div class="col-md-4 mt-4 mb-4" v-for="report in reports" :key="report.id">
          <router-link
            :to="{ name: report.router_link }"
            class="card-adela-anchor"
            v-if="report.condition"
            >
            <!-- v-if="$can('read', report.subject)" -->
            <div class="card-adela-item card-adela-diseno">
              <div class="card-adela-badge" style="background-color:#513692">
                <font-awesome-icon :icon="['fa', report.icon]" />
              </div>
              <div class="card-adela-category">
                <h2>{{ report.title }}</h2>
                <span>{{ report.description }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">

export default {
  data () {
    return {
      conditionX: false,
      reports: [
        {
          id: 1,
          icon: 'shopping-bag',
          title: 'Reporte de Compras',
          description: 'Reporte de compra por alamacen.',
          router_link: 'compras',
          subject: 'GeneralReport',
          condition: true
        },
        {
          id: 2,
          icon: 'users',
          title: 'Reporte Ventas',
          description: 'Reportes',
          router_link: 'salesList',
          subject: 'UsersReport',
          condition: true
        },
        {
          id: 3,
          icon: 'undo-alt',
          title: 'Devolucion a Proveedor',
          description: 'Reportes',
          router_link: 'providerDevolutions',
          subject: 'UsersReport',
          condition: true
        },
        {
          id: 4,
          icon: 'ticket-alt',
          title: 'Reporte de Vales',
          description: 'Reportes',
          router_link: 'reportTickets',
          subject: 'UsersReport',
          condition: true
        },
        {
          id: 5,
          icon: 'shoe-prints',
          title: 'Reporte de Productos',
          description: 'Reportes',
          router_link: 'reportProducts',
          subject: 'UsersReport',
          condition: true
        }
      ]
    }
  },
  computed: {
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  mounted () {
    console.log('this.myRoleId === 1', this.myRoleId === 1)
    this.conditionX = this.myRoleId === 1
    this.reports.push(
      {
        id: 6,
        icon: 'dollar-sign',
        title: 'Utilidad',
        description: 'Utilidad bruta.',
        router_link: 'reportUtility',
        subject: 'EnterprisesReport',
        condition: this.conditionX
      }
    )
  }
}
</script>
